import React, { useRef, useState } from 'react';
import { FAQsProps } from '../../Default/FAQs';

export default function FAQs({ faqs }: FAQsProps) {

  return (
    <div className='border-t-2 border-t-gray-200'>
      {faqs.map((faq) => <FAQItem key={faq.id} faq={faq} />)}
    </div>
  );
}
const FAQItem = ({ faq }: { faq: any }) => {


  const answerRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);

  const handleToggleClick = () => {
    if (height === 0) {
      const answerHeight = answerRef?.current?.clientHeight || 0;
      setHeight(answerHeight);
    }
    else {
      setHeight(0);
    }
  };

  let data = JSON.parse(faq.data);
  const { Question, Answer } = data;

  return (
    <div key={faq.id} className="w-full">
      <h3 onClick={handleToggleClick} className="border-b-2 cursor-pointer px-3 py-5 text-2xl font-bold">
        <div className="flex justify-between">
          <span>{Question}</span>
          <span className='w-[30px] flex justify-center items-center'>{height !== 0 ? '-' : '+'}</span>
        </div>
      </h3>
      <div
        className={`transition-max-height ease-out duration-300 overflow-hidden`}
        style={{ maxHeight: `${height}px` }}
      >
        <div ref={answerRef} className='p-5 bg-gray-100 text-xl'>
          <div dangerouslySetInnerHTML={{ __html: Answer }}></div>
        </div>
      </div>
    </div>
  );
};
